import { render, staticRenderFns } from "./UserFollower.vue?vue&type=template&id=1f514bc6&"
import script from "./UserFollower.vue?vue&type=script&lang=js&"
export * from "./UserFollower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports